import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { JsonExporterService } from 'mat-table-exporter';
import { forkJoin, Observable, Subject } from 'rxjs';
import { DocumentManagementService } from './document-management.service';
import { MessagingService } from './messaging.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  NetApiUrl: string = Constants.CORE_API_BASE_URL;
  notificationUrl: string = Constants.API_SIGNALR_BASE_URL;
  private connection: any = new signalR.HubConnectionBuilder().withUrl(Constants.CORE_API_BASE_URL.replace('/api', '') + "chatsocket", {
    skipNegotiation: true,
    transport: signalR.HttpTransportType.WebSockets
  })
    .configureLogging(signalR.LogLevel.Information)
    .build();
  readonly apiUrl = Constants.CORE_API_BASE_URL;

  private sharedObj = new Subject<any>();

  constructor(private http: HttpClient, private documentService: DocumentManagementService) {
    this.connection.onclose(async () => {
      await this.start();
    });
    this.connection.on("WebsocketData", (instance: string) => {
      this.sharedObj.next(instance);
    });
    this.start();
  }

  public async start() {
    // try {
    //   await this.connection.start({ withCredentials: false });
    //   console.log("connected");
    // } catch (err) {
    //   console.log(err);
    //   setTimeout(() => this.start(), 5000);
    // }
  }

  public broadcastMessage(msgDto: any) {
    var form = new FormData();
    form.append('data', JSON.stringify(msgDto));
    this.http.post(this.apiUrl + "notification/sendRequest", form).subscribe();
  }

  public broadcastMessageMultiple(msgDto: any[], deviceToken: any[] = []) {
    var form = new FormData();
    form.append('data', JSON.stringify(msgDto));
    this.http.post(this.apiUrl + "notification/sendRequestMultiple", form).subscribe();
    let key = {
      registration_ids: deviceToken,
      notification: {
        title: msgDto[0].title,
        body: msgDto[0].description
      }
    }
    this.sendFirebaseNotification(key).subscribe((res) => {
    });
  }

  public retrieveMappedObject(): Observable<any> {
    return this.sharedObj.asObservable();
  }


  addnotification(data: any): Observable<any[]> {
    return new Observable(observer => {
      this.http.post<any[]>(this.NetApiUrl + 'Roles/addnotificationsrolewise', data).subscribe((res) => {
        let deviceTokenArr = res.map(x => x.deviceToken).filter(x => x != null);
        if (res != null && res.length > 0) {
          this.broadcastMessageMultiple(res, deviceTokenArr);
        }
      });
    });
  }

  sendNotificationRoleWise (data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Notification/SendNotificationsToUserRoleWise', data);
  }

  usernotifications(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.kpiUrl + 'api/usernotifications', data);
    return this.http.post<any[]>(this.NetApiUrl + 'Users/Usernotifications', data);
  }

  updatenotificationstatus(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Notification/updateNotification', data);
  }

  addnotificationuserwise(data: any): Observable<any[]> {
    return new Observable(observer => {
      this.http.post<any[]>(this.NetApiUrl + 'Notification/AddUserWiseNotifications', data).subscribe((res) => {
        let deviceTokenArr = res.map(x => x.deviceToken).filter(x => x != null);
        if (res != null && res.length > 0) {
          this.broadcastMessageMultiple(res, deviceTokenArr);
        }
      });
    });
  }

  GetUserIdByEmpInfoIdBulk(data: any): Observable<any> {
    return this.http.post<any[]>(
      this.baseUrl + 'notification/GetUserIdByEmpInfoIdBulk',
      data
    );
  }

  addnotificationmappeduserwise(data: any): Observable<any[]> {
    return new Observable(observer => {
      if (Array.isArray(data.userId)) {
        data.userId = data.userId.toString(); //converting data from array to comma seperated
      }
      this.http.post<any[]>(this.NetApiUrl + 'UserNotification/addNotificationsMappeduserwise', data).subscribe((res) => {
        let deviceTokenArr = res.map(x => x.deviceToken).filter(x => x != null);
        if (res != null && res.length > 0) {
          this.broadcastMessageMultiple(res, deviceTokenArr);
        }
      });
    });
  }

  addnotificationdepartmentwise(data: any): Observable<any[]> {
    return new Observable(observer => {
      this.http.post<any[]>(this.NetApiUrl + 'Notification/AddDepartmentWiseNotifications', data).subscribe((res) => {
        let deviceTokenArr = res.map(x => x.deviceToken).filter(x => x != null);
        if (res != null && res.length > 0) {
          this.broadcastMessageMultiple(res, deviceTokenArr);
        }
      });
    });
  }

  ClearNotification(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Notification/ClearNotification', data);
  }

  ClearNotificationById(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Notification/ClearNotificationById', data);
  }

  addNotificationEmpIdWise(data: any): Observable<any[]> {
    let param = {
      empInfoId: data.empInfoId
    }
    this.documentService.GetUserIdByEmpInfoId(param).subscribe((res) => {
      let param1 = {
        userId: res.userId
      }
      data.userId = param1.userId;
      this.broadcastMessage(data);
      this.getUserDeviceToken(param1).subscribe((res1) => {
        var key = {
          notification: {
            title: data.title,
            body: data.desc
          },
          to: res1.token
        }
        this.sendFirebaseNotification(key).subscribe((res) => {
        });
      });


    });

    return this.http.post<any[]>(this.NetApiUrl + 'Notification/AddNotificationEmpIdWise', data);
  }

  addUserDeviceToken(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Notification/addUserDeviceToken', data);
  }

  getUserDeviceToken(data: any): Observable<any> {
    return this.http.post<any[]>(this.NetApiUrl + 'Notification/getUserDeviceToken', data);
  }
  getUserDeviceTokenBulk(data: any): Observable<any> {
    return this.http.post<any[]>(this.NetApiUrl + 'Notification/getUserDeviceTokenBulk', data);
  }

  getUserIdByRoleName(data: any): Observable<any> {
    return this.http.post<any>(this.NetApiUrl + 'Notification/getUserIdByRoleName', data);
  }

  sendFirebaseNotification(data: any): Observable<any> {
    return this.http.post("https://fcm.googleapis.com/fcm/send", data);
  }

}
